import React from 'react';
import { isAlwaysOnTitleBarEmpty } from '../functions.web';
export default ({ visible, children, id }) => (React.createElement("div", { className: `subject${isAlwaysOnTitleBarEmpty() ? '' : ' with-always-on'}${visible ? ' visible' : ''}`, id: id },
    React.createElement("div", { className: 'subject-info-container infobar-interactable' }, children)));
